import { AppError } from './appError.js';
import { AISErrorsCodes } from './AISErrorCodes.js';
import { ErrorCodes } from './errorCodes.js';
import '../tslib.es6-b2cb7a63.js';

function formatAISError(error, response) {
    if (response === void 0) { response = null; }
    var message = '';
    var name = 'Unknown error';
    var netCode = null;
    var aisCode = null;
    var errCode = ErrorCodes.NET_ERR;
    if (response === null || response === void 0 ? void 0 : response.statusText) {
        name = message = response.statusText;
    }
    if (response === null || response === void 0 ? void 0 : response.status) {
        netCode = response.status;
    }
    if (error instanceof TypeError) {
        errCode = ErrorCodes.APP_ERR;
        message = error.message || message;
        name = error.name || name;
    }
    else if (error instanceof Error) {
        errCode = netCode && netCode < 500 ? ErrorCodes.AIS : ErrorCodes.NET_ERR;
        message = error.message || message;
        name = error.name || name;
    }
    else if (error) { //AMS response
        errCode = ErrorCodes.AIS;
        if (error === null || error === void 0 ? void 0 : error.userMessage) {
            message = error.userMessage;
        }
        else if (error === null || error === void 0 ? void 0 : error.message) {
            message = error.message;
        }
        else if (error === null || error === void 0 ? void 0 : error.displayMessage) {
            message = error.displayMessage;
        }
        else if (error === null || error === void 0 ? void 0 : error.developerMessage) {
            message = error.developerMessage;
        }
        else if (error === null || error === void 0 ? void 0 : error.detailMessage) {
            message = error.detailMessage;
        }
        if (error === null || error === void 0 ? void 0 : error.code) {
            aisCode = error === null || error === void 0 ? void 0 : error.code;
        }
        else if (error === null || error === void 0 ? void 0 : error.resultCode) {
            aisCode = error === null || error === void 0 ? void 0 : error.resultCode;
        }
        else if (error === null || error === void 0 ? void 0 : error.statusCode) {
            aisCode = error === null || error === void 0 ? void 0 : error.statusCode;
        }
        if (AISErrorsCodes[parseInt(aisCode)]) {
            name = AISErrorsCodes[parseInt(aisCode)];
        }
    }
    return new AppError(errCode, name, "" + (aisCode ? '[' + aisCode + '] ' : '') + (message ? message + '' : '') + " " + (netCode ? '(' + netCode + ')' : ''), {
        aisCode: aisCode,
        netCode: netCode,
        errCode: errCode,
        name: name,
        message: message,
        response: response,
        origError: error
    });
}

export { formatAISError };
